import ClicRDV from "@/services/ClicRDV";
import { toastMessage } from "@/services/utils";

// ==================
// NAME
// ==================
const name = "Session";

// ================
// DATA
// ================
const data = () => ({
	loading: false,
	email: null,
	password: null
});

// ================
// METHODS
// ================
const onFormSubmitted = function (e) {
	this.loading = true;

	if (this.email && this.password) {
		ClicRDV.authenticate(this.email, this.password).then(response => {
			ClicRDV.authenticateV1(this.email, this.password).then(_response => {
				this.$store.commit("addToken", response.token);
				this.$store.commit("setUser", response.user);
				this.$router.push("home");
				this.$toasted.show("Authentifié avec succès !", {
					position: "bottom-center",
					duration: 3000,
					action: {
						text: "Fermer",
						onClick: (e, toastObject) => {
							toastObject.goAway(0);
						}
					}
				});
			});
		}).catch(error => {
			const { response: { data: { error:responseMessage } } } = error;

			if (responseMessage) {
				toastMessage.bind(this)(responseMessage, 6000);
			}			
		}).finally(() => {
			this.loading = false;
		});
	}

	e.preventDefault();
};

export default {
	name,
	data,
	methods: {
		onFormSubmitted
	}
}; 